import { configureStore } from "@reduxjs/toolkit";
import {
  answerReportSlice,
  assignmentReportSlice,
  assignmentSlice,
  authSlice,
  commonSlice,
  companySlice,
  employeeSlice,
  moduleSlice,
  salaryReportSlice,
  taskSlice,
  questionnaireReportSlice,
} from "./slices";

const reducer = {
  auth: authSlice,
  common: commonSlice,
  employee: employeeSlice,
  salaryReport: salaryReportSlice,
  questionReport: questionnaireReportSlice,
  assignmentReport: assignmentReportSlice,
  answerReport: answerReportSlice,
  company: companySlice,
  module: moduleSlice,
  task: taskSlice,
  assignment: assignmentSlice,
};

export default configureStore({
  reducer: reducer,
  devTools: true,
});
